/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Ranking_GlobalInputs */

const en_us2_clubs_ranking_global = /** @type {(inputs: Clubs_Ranking_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a ranking visible to people in clubs with rankings, and the club is listed among open clubs.`)
};

const pt_br2_clubs_ranking_global = /** @type {(inputs: Clubs_Ranking_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com ranking visível para quem participa de clubes com ranking, e o clube aparece na lista de clubes abertos.`)
};

const es_419_clubs_ranking_global = /** @type {(inputs: Clubs_Ranking_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con ranking visible para quienes están en clubes con ranking, y el club aparece entre los clubes abiertos.`)
};

const pt_pt2_clubs_ranking_global = /** @type {(inputs: Clubs_Ranking_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com classificação visível para quem está em clubes com classificação, e o clube aparece na lista de clubes abertos.`)
};

const fr_fr2_clubs_ranking_global = /** @type {(inputs: Clubs_Ranking_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec un classement visible par les membres des clubs à classement, et le club figure parmi les clubs ouverts.`)
};

const de_de2_clubs_ranking_global = /** @type {(inputs: Clubs_Ranking_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit einer Rangliste, die alle in Clubs mit Rangliste sehen, und der Club steht unter den offenen Clubs.`)
};

const it_it2_clubs_ranking_global = /** @type {(inputs: Clubs_Ranking_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con una classifica visibile a chi è in club con classifica, e il club appare tra i club aperti.`)
};

/**
* | output |
* | --- |
* | "With a ranking visible to people in clubs with rankings, and the club is listed among open clubs." |
*
* @param {Clubs_Ranking_GlobalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_ranking_global = /** @type {((inputs?: Clubs_Ranking_GlobalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Ranking_GlobalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_ranking_global(inputs)
	if (locale === "es-419") return es_419_clubs_ranking_global(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_ranking_global(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_ranking_global(inputs)
	if (locale === "de-DE") return de_de2_clubs_ranking_global(inputs)
	if (locale === "it-IT") return it_it2_clubs_ranking_global(inputs)
	return en_us2_clubs_ranking_global(inputs)
});
export { clubs_ranking_global as "clubs.ranking_global" }